const mapChannels = channels => ({
    atm: channels.atm > 0,
    tpv: channels.pos > 0,
    online: channels.ecom > 0,
});

export default mapChannels;
